module.exports = __webpack_public_path__ + "img/general_contractor.b0d01c51.jpg";